import { TextButton } from 'cdk-radial';
import './BackButton.scss';

const BackButton = (props) => {
    const { icon, text, onLoadSubscriptionManagmentScreen } = props;
    return (
        <div className="link-alignment">
            <TextButton
                icon={icon}
                onClick={onLoadSubscriptionManagmentScreen}
                text={text}
            />
        </div>
    )
}

export default BackButton;
